import React, { useState } from "react";
import {
  Modal,
  AutoComplete,
  Input,
  Form,
  Upload,
  DatePicker,
  notification,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import axiosInstance from "utilities/axios";

const ShippingPopup = ({ itemId, isOpen, onClose, onSubmit }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const updateShipping = (values) => {
    setLoading(true);
    var formData = new FormData();

    if (values.shippingCompany) {
      formData.append("shippingCompany", values.shippingCompany);
    }

    if (values.shippingNumber) {
      formData.append("shippingNumber", values.shippingNumber);
    }

    if (values.shippingDate) {
      formData.append("shippingDate", values.shippingDate.format("YYYY-MM-DD"));
    }

    if (values.file?.file) {
      formData.append("file", values.file.file);
    }

    axiosInstance
      .post(`/equipment/requests/${itemId}/ship`, formData)
      .then((response) => {
        onSubmit();
        onClose();
        notification.success({
          message: "Success",
          description: "Request marked as shipped",
        });
      })
      .catch((error) => {
        notification.error({
          message: "Error",
          description: error.message,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Modal
      title="Enter Shipping Information"
      open={isOpen}
      onCancel={onClose}
      okText="Ship"
      okButtonProps={{ loading: loading }}
      onOk={form.submit}
      destroyOnClose={true}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={(values) => updateShipping(values)}
      >
        <Form.Item label="Enter Shipping Number" name="shippingNumber">
          <Input />
        </Form.Item>
        <Form.Item label="Enter Shipping Company" name="shippingCompany">
          <AutoComplete
            defaultOpen={false}
            placeholder="Enter any shipping company"
            filterOption={(inputValue, option) =>
              option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !==
              -1
            }
            options={[
              { value: "Canada Post" },
              { value: "UPS" },
              { value: "Purolator" },
              { value: "FedEx" },
              { value: "DHL" },
            ]}
          />
        </Form.Item>
        <Form.Item label="Enter Shipping Date" name="shippingDate">
          <DatePicker />
        </Form.Item>
        <Form.Item label="Upload Shipping Document" name="file">
          <Upload.Dragger
            action="/upload.do"
            listType="text"
            beforeUpload={() => false}
            maxCount={1}
          >
            <p className="ant-upload-drag-icon">
              <UploadOutlined />
            </p>
            <p className="ant-upload-text">
              Click or drag file to this area to upload
            </p>
          </Upload.Dragger>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ShippingPopup;
